export default __webpack_public_path__ + "static/media/admin.d420a7b9.svg";